import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {AgBoxS, AgContentS, AgIconS} from '@/components/ag'
import {IonPage, IonToggle} from '@ionic/vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  description: {type: String},
  modelValue: {default: false, type: Boolean},
  title: {default: '', type: String},
},
  emits: [
  'update:modelValue',
],
  setup(__props, { emit }) {

const props = __props






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), { css: {width: '100%', dp: 'flex', direction: 'row', py: 16} }, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'column', grow: 1} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {typography: 'h7', color: 'font', fontWeight: 700} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'h10', color: '#8F929B'} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.description), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToggle), {
            mode: "ios",
            style: {'--background-checked': '#4360EC'},
            checked: __props.modelValue,
            onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.checked)))
          }, null, 8, ["checked"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})